export const branchesEquipmentsConsumptionsTotalizerColumns = [
  {
    value: 'displayName',
    label: 'Produto',
  },
  {
    value: 'totalQuantity',
    label: 'Quantidade Total',
    className: 'print:text-nowrap',
  },
  {
    value: 'accumulatedUsage',
    label: 'Quilometragem Acumulada',
    className: 'print:text-nowrap',
  },
  {
    value: 'averageUsagePerQuantity',
    label: 'Média de KM/L do Produto',
    className: 'print:text-nowrap',
  },
  {
    value: 'totalValue',
    label: 'Valor Total',
    className: 'text-right print:text-nowrap',
  },
];
